var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDepartment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.5776V19.6349C22 20.9397 20.9382 22.0015 19.6334 22.0015H9.06641V20.0585L19.1954 14.2109H19.6334C20.9382 14.2109 22 15.2726 22 16.5776Z",
    fill: "#4C4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7174 12.4189L9.22498 18.4767C17.078 4.87404 16.5976 5.74383 16.7418 5.36986C17.6472 5.26932 18.5707 5.69935 19.0549 6.53824L20.5837 9.18586C21.2359 10.316 20.8472 11.7662 19.7174 12.4189Z",
    fill: "#4C4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3828 5.23556L9.06641 16.1758V0.795509C9.79335 0.112037 10.9302 -0.0678947 11.8684 0.474082L14.5161 2.00249C15.6462 2.65525 16.0347 4.10545 15.3828 5.23556Z",
    fill: "#4C4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42397 0H2.36664C1.05962 0 0 1.05962 0 2.36664V18.7721C0 20.555 1.44499 22 3.22786 22H7.7906V2.36664C7.7906 1.05962 6.73099 0 5.42397 0ZM3.91016 18.7344C3.55415 18.7344 3.26562 18.4458 3.26562 18.0898C3.26562 17.7338 3.55415 17.4453 3.91016 17.4453C4.26616 17.4453 4.55469 17.7338 4.55469 18.0898C4.55469 18.4458 4.26616 18.7344 3.91016 18.7344Z",
    fill: "#4C4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDepartment);
export default __webpack_public_path__ + "static/media/user-department.c241cd1f39166240dfa561b38792429d.svg";
export { ForwardRef as ReactComponent };